import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({

    selectors: {
      emailField: '.js-EmailValue'
    },

    events: {
      'click .js-EmailSave': 'emailSave'
    },

    initialize: function () {

    },

    emailSave: function () {
      var emailValue = $(this.selectors.emailField).val().trim();

      if (emailValue !== "") {
        sessionStorage.setItem("emailRecover", emailValue);
      }
    }

  });
